export const forgotPasswordRequest = {
  authority: 'https://ctid.b2clogin.com/ctid.onmicrosoft.com/b2c_1_reset',
};
